import React from 'react'

import SlideInner from '../SlideInner/SlideInner'
import styles from './LandingGlobalMap.scss'
import {
    LANDING_GLOBAL_MAP_HEADER,
    LANDING_GLOBAL_MAP_MESSAGE1,
    LANDING_GLOBAL_MAP_MESSAGE2,
} from './translations'

const LandingGlobalMap = () => {
    return (
        <SlideInner
            title={LANDING_GLOBAL_MAP_HEADER}
            description={[LANDING_GLOBAL_MAP_MESSAGE1, LANDING_GLOBAL_MAP_MESSAGE2]}
        >
            <div className={styles.imageContainer}/>
        </SlideInner>
    )
}

export default LandingGlobalMap


// WEBPACK FOOTER //
// ./containers/Landing/components/LandingGlobalMap/LandingGlobalMap.jsx